:host {
  padding: calc(var(--spacer) * 3);
  --title-height: 14px;
}

.company-selector {
  width: auto;
}

#integrationSelectCompanyWrapper {
  width: 35%;
  margin: auto;
}

#select-company-title {
  height: var(--title-height);
  background-color: var(--surface-0);
  box-sizing: border-box;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  line-height: var(--title-height);
  padding-bottom: calc(var(--spacer) * 3);
  text-align: center;
}

#select-company-dropdown {
  width: 201px;
  margin: auto;
}
